import i18next from 'i18next';

import { getPdfFile } from 'common/api/v1/renderTemplate';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import { SET_IS_DOWNLOADING } from '../actionTypes';
import { multiTemplateReviewActions } from '../reducer';

import downloadFile from './downloadFile';

export default (contentId, downloadFormat, name = i18next.t('File')) =>
    (dispatch) => {
        let baseUrl = import.meta.env.VITE_LOCAL_RENDER_URL;

        if (!baseUrl) {
            const protocol = window.location.protocol;
            const hostname = window.location.hostname;
            const port = window.location.port;
            baseUrl = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
        }

        const newValues = {
            baseUrl,
            quality: downloadFormat,
            templateId: contentId,
            renderName: name,
        };

        dispatch(multiTemplateReviewActions[SET_IS_DOWNLOADING](true));

        return getPdfFile(newValues)
            .then((response) => {
                dispatch(multiTemplateReviewActions[SET_IS_DOWNLOADING](false));
                const url = window.URL.createObjectURL(
                    new Blob([response.data]),
                );
                dispatch(downloadFile(name, url, 'pdf'));
                showToast({ body: i18next.t('It was created successfully') });
            })
            .catch((error) => {
                dispatch(multiTemplateReviewActions[SET_IS_DOWNLOADING](false));
                showReponseErrorsAsAlert(dispatch, error?.response);
            });
    };
